// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { ProductPartnerAdvantagesImplModule } from "../product_partner_advantages_impl_module/ProductPartnerAdvantagesImplModule";

@Observer
@Component({
  mixins: [template],
  components: {
    ProductPartnerAdvantagesImplModule,
  },
})
export class ProductPartnerAdvantagesAutomaticModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    if (this.currentProduct) {
      return this.currentProduct.is_van_solution ? "black" : "white";
    }

    return "white";
  }

  get currentProduct() {
    return this.$store.conversionWorldProduct.current;
  }

  get partnerAdvantages() {
    if (this.currentProduct) {
      return this.currentProduct.partner_advantages;
    }

    return null;
  }

  get modelAdvantages() {
    if (this.currentProduct) {
      return this.currentProduct.model_advantages;
    }

    return null;
  }
}
